import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, Copy, Share2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { Button } from "@/components/ui/button";

export default function Referrals() {
  const { t } = useLang();
  useSEO("Referrals");
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/referrals").then((r) => setData(r.data)).catch(() => {}); }, []);

  const link = data ? `${window.location.origin}/signup?ref=${data.referral_code}` : "";
  const copy = (text) => { navigator.clipboard.writeText(text); toast.success("Copied to clipboard"); };

  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl font-bold text-white">{t("referrals")}</h1>

      <div className="grid sm:grid-cols-3 gap-4">
        <div className="card-surface rounded-2xl p-6">
          <p className="text-sm text-slate-400">Your Referral Code</p>
          <div className="mt-2 flex items-center gap-2">
            <span className="font-mono text-xl text-brand-cyan" data-testid="referral-code">{data?.referral_code || "—"}</span>
            {data && <button onClick={() => copy(data.referral_code)} className="text-slate-500 hover:text-brand-cyan" data-testid="copy-code"><Copy className="h-4 w-4" /></button>}
          </div>
        </div>
        <div className="card-surface rounded-2xl p-6">
          <p className="text-sm text-slate-400">Total Referrals</p>
          <p className="mt-2 font-display text-3xl font-bold text-white" data-testid="referral-count">{data?.count ?? 0}</p>
        </div>
        <div className="card-surface rounded-2xl p-6">
          <p className="text-sm text-slate-400">Leaderboard</p>
          <p className="mt-2 text-sm text-slate-500">Coming soon — configured by admin.</p>
        </div>
      </div>

      <div className="card-surface rounded-2xl p-6">
        <p className="text-sm text-slate-400 mb-2">Share your referral link</p>
        <div className="flex flex-col sm:flex-row gap-2">
          <div className="flex-1 rounded-lg bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-slate-300 truncate font-mono" data-testid="referral-link">{link}</div>
          <Button onClick={() => copy(link)} className="gradient-brand text-brand-navy font-semibold" data-testid="copy-link"><Share2 className="h-4 w-4 mr-2" /> Copy Link</Button>
        </div>
      </div>

      <div className="card-surface rounded-2xl p-6">
        <h2 className="font-display font-semibold text-white mb-4">Referred Members</h2>
        {!data || data.referrals.length === 0 ? <p className="text-sm text-slate-500">No referrals yet. Share your link to grow your network.</p>
          : (
            <div className="space-y-2">
              {data.referrals.map((r, i) => (
                <div key={i} className="flex items-center justify-between rounded-lg bg-white/5 px-4 py-3">
                  <span className="text-sm text-white">{r.name}</span>
                  <span className="text-xs text-slate-500">{new Date(r.joined_at).toLocaleDateString()}</span>
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
